import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 768;

export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        // 1. Function to update the state based on screen width
        const handleResize = () => {
            setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
        };

        // 2. Set initial state on component mount
        handleResize();

        // 3. Add an event listener to update on resize
        window.addEventListener('resize', handleResize);

        // 4. Clean up the listener when the component unmounts
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); // The empty array ensures the effect runs only once

    return isMobile; // Return the current state
};